/** All API endpoint paths. Services reference these — never inline URLs. */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    VERIFY_OTP: '/auth/verify-otp',
    MFA_VERIFY: '/auth/mfa/verify',
    RESET_PASSWORD: '/auth/reset-password',
    PERMISSIONS: '/auth/permissions',
    ME_PERMISSIONS: '/auth/me/permissions',
    SWITCH_ASSIGNMENT: '/auth/switch-assignment',
    SWITCH_CENTERS: '/auth/switch-centers',
    TENANT: '/auth/tenant',
    SWITCH_CONTEXT: '/auth/switch-context',
    ME: '/users/profile',
    SET_INITIAL_PASSWORD: '/users/set-initial-password',
  },
  ADMIN: {
    USERS: '/admin/users',
    USERS_BULK_ACTION: '/admin/users/bulk-action',
    USER: (id) => `/admin/users/${id}`,
    USER_DELETE_PREVIEW: (id) => `/admin/users/${id}/delete-preview`,
    USER_DEACTIVATE_PREVIEW: (id) => `/admin/users/${id}/deactivate-preview`,
    USER_STATUS: (id) => `/admin/users/${id}/status`,
    // Multiple roles per user (one email, several roles — access is the union).
    USER_ROLES: (id) => `/admin/users/${id}/roles`,
    USER_ROLE: (id, roleId) => `/admin/users/${id}/roles/${roleId}`,
    USER_ROLE_CHANGE_IMPACT: (id) => `/admin/users/${id}/role-change-impact`,
    USER_PERMISSION_OVERRIDES: (id) => `/admin/users/${id}/permission-overrides`,
    USER_PERMISSION_OVERRIDE_RESOLVE: (id, overrideId) =>
      `/admin/users/${id}/permission-overrides/${overrideId}/resolve`,
    // A super admin's own overrides (platform master only).
    USER_ORG_PERMISSION_OVERRIDES: (id) => `/admin/users/${id}/organization-permission-overrides`,
    ROLES: '/admin/roles',
    ROLE: (id) => `/admin/roles/${id}`,
    ROLE_USERS: (id) => `/admin/roles/${id}/users`,
    ROLES_DEFAULT_PROTECTION: '/admin/roles/default-protection-status',
    STARTUPS: '/admin/startups',
  },
};

export default API_ENDPOINTS;
